import _         from 'lodash'
import React     from 'react'
import PropTypes from 'prop-types'

import { Col, Form, HelpBlock, FormGroup, FormControl, ControlLabel, \
         Radio as BSRadio, Button as BSButton, Checkbox as BSCheckbox } from 'react-bootstrap'

import CustomSelect from './select'

class HorizontalForm extends React.Component
  @childContextTypes =
    labelCols:   PropTypes.number.isRequired
    controlCols: PropTypes.number.isRequired

  render: ->
    <Form horizontal id={@props.id} className={@props.className}>
      {@props.children}
    </Form>

  getChildContext: ->
    labelCols:   @props.labelCols ? 4
    controlCols: @props.labelCols ? 8

class HorizontalForm.Group extends React.Component
  @contextTypes =
    labelCols:   PropTypes.number.isRequired
    controlCols: PropTypes.number.isRequired

  render: ->
    valid     = if @props.valid is undefined then true else @props.valid
    helpBlock = <HelpBlock>{@props.help}</HelpBlock> if @props.help

    <FormGroup id={@props.id} className={@props.className} validationState={'error' unless valid}>
      <Col componentClass={ControlLabel} xs={@context.labelCols}>{@props.label}</Col>
      <Col xs={@context.controlCols}>
        {@props.children}
        {helpBlock}
      </Col>
    </FormGroup>

class HorizontalForm.Offset extends React.Component
  @contextTypes =
    labelCols:   PropTypes.number.isRequired
    controlCols: PropTypes.number.isRequired

  render: ->
    <FormGroup id={@props.id}>
      <Col xs={@context.controlCols} xsOffset={@context.labelCols}>
        {@props.children}
      </Col>
    </FormGroup>

class HorizontalForm.Control extends React.Component
  render: ->
    <HorizontalForm.Group {...@groupProps()}>
      <FormControl {...@controlProps()} />
    </HorizontalForm.Group>

  groupProps: ->
    _.pick(@props, 'id', 'className', 'label', 'valid', 'help')

  controlProps: ->
    { ..._.pick(@props, 'type', 'value', 'placeholder', 'disabled', 'inputRef', 'onFocus'), \
      id:        @props.controlId,                                                          \
      className: @props.controlClassName,                                                   \
      autoFocus: @props.autofocus or @props.autoFocus,                                      \
      onChange: ((e) => @props.onChange(e.target.value)),                                   \
      onKeyPress: @handleKeyPress }

  handleKeyPress: (event) =>
    event.preventDefault() if event.key == 'Enter'
    @props.onKeyPress?(event)

class HorizontalForm.TextArea extends HorizontalForm.Control
  controlProps: ->
    { ..._.omit(super(), 'onKeyPress'), componentClass: 'textarea', rows: @props.rows }

class HorizontalForm.Static extends React.Component
  render: ->
    <HorizontalForm.Group id={@props.id} label={@props.label}>
      <FormControl.Static>{@props.value}</FormControl.Static>
    </HorizontalForm.Group>

class HorizontalForm.Checkbox extends React.Component
  render: ->
    { id, value, label, onChange, children, managed = true } = @props

    if managed
      checkbox =
        <BSCheckbox defaultChecked={value} onChange={(e) => onChange(e.target.checked)}>
          {children or label}
        </BSCheckbox>
    else
      checkbox =
        <BSCheckbox readOnly checked={value}>
          {children or label}
        </BSCheckbox>

    <HorizontalForm.Offset id={id}>{checkbox}</HorizontalForm.Offset>

class HorizontalForm.Radio extends React.Component
  render: ->
    <HorizontalForm.Offset id={@props.id}>
      <BSRadio checked={@props.value} onChange={(e) => @props.onChange(e.target.checked)}>
        {@props.children or @props.label}
      </BSRadio>
    </HorizontalForm.Offset>

class HorizontalForm.Button extends React.Component
  render: ->
    # TODO: rename caption to label in order to be consistent with the rest
    bsStyle = @props.bsStyle ? 'success'

    <HorizontalForm.Offset>
      <BSButton {...@props} type={@props.type ? 'button'} bsStyle={bsStyle}>
        {@props.caption}
      </BSButton>

    </HorizontalForm.Offset>

class HorizontalForm.Select extends React.Component
  render: ->
    groupProps  = _.pick(@props, 'id', 'label', 'valid', 'help')
    selectProps = _.pick(@props, 'value', 'options', 'allowBlank', 'onChange')

    <HorizontalForm.Group {...groupProps}>
      <CustomSelect {...selectProps} />
    </HorizontalForm.Group>

export default HorizontalForm
